<template>
    <div class="md-card" v-on:fetchData="fetchData">
        <modal
            v-if="showModal"
            @close="modalHide"
            modalSize="modal-container-xl"
        >
            <template slot="header">
                <h4 class="modal-title">{{ $t("add_patient") }}</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="modalHide"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>
            <template slot="body">
                <md-card>
                    <md-card-content>
                        <div class="md-layout-item md-size-100">
                            <form ref="form" id="newPatientForm">
                                <patient-form
                                    @on-validated="onFormValidated"
                                    ref="formulario"
                                    :paciente.sync="datosFormulario"
                                >
                                </patient-form>
                            </form>
                        </div>
                    </md-card-content>
                </md-card>
            </template>

            <template slot="footer">
                <md-button class="md-danger md-simple" @click="modalHide"
                    >{{ $t("cancel") }}
                </md-button>
                <md-button @click="submit()" class="md-success"
                    >{{ $t("save") }}
                </md-button>
            </template>
        </modal>

        <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
                <md-icon>people</md-icon>
            </div>
            <md-card-header-text>
                <h4 class="title">{{ $t(tableTitle) }}</h4>
                <div class="pull-right">
                    <md-button
                        v-if="permissionsAdminCentro"
                        v-show="!esIOS"
                        class="md-success"
                        @click="openModal()"
                    >
                        {{ $t("add_patient") }}
                    </md-button>
                </div>

                <md-field class="md-layout-item md-size-20 section-filter">
                    <label>{{ $t("section") }}</label>
                    <md-select
                        v-model="selectedSections"
                        ref="sections"
                        multiple
                    >
                        <md-option
                            v-for="section in sections"
                            :value="section.id"
                            v-bind:key="section.id"
                        >
                            {{ section.nombre }}
                        </md-option>
                    </md-select>
                </md-field>
            </md-card-header-text>
        </md-card-header>
        <div class="md-card-content">
            <div class="md-layout">
                <patient
                    @fetchData="fetchData"
                    ref="paciente_item"
                    :objeto="pp"
                    :permissionsAppQR="permissionsAppQR"
                    :permissionsAdminCentro="permissionsAdminCentro"
                    :permissionsAdminCadena="permissionsAdminCadena"
                    :full-information="response.serviciosAvanzados"
                    v-for="pp in filteredPatients"
                    :key="pp.id"
                >
                </patient>
            </div>
        </div>
    </div>
</template>

<script>
import { authHeader } from "../../helpers/auth-header";
import { handleResponse } from "../../helpers/handle-response";
import Modal from "../Modal";
import { isIOS } from "mobile-device-detect";
import { EventBus } from "../../helpers/EventBus";

import patient from "./patient";
import patientForm from "./patientForm";

let BACKEND_API = process.env.VUE_APP_BACKEND_API;

export default {
    name: "patient_list",
    components: { Modal, patient, patientForm },
    destroyed() {
        //clearInterval(this.refreshInterval);
        this.refreshInterval = null;
        this.permissionsAppQR = false;
        this.permissionsAdminCentro = false;
        this.permissionsAdminCadena = false;
        this.sections = [];
        this.selectedSections = [];
        this.formData = [];
        this.showModal = false;
        this.tableTitle = "patient_list";
        this.isLoading = false;
        this.datosFormulario = {};
        this.response = {};
    },
    created() {
        //Obtengo la lista de pacientes
        this.setPermissions();
        this.fetchData();
        EventBus.$on("cambio-centro", this.fetchData);
    },
    data() {
        return {
            esIOS: isIOS,
            refreshInterval: null,
            permissionsAppQR: false,
            permissionsAdminCentro: false,
            permissionsAdminCadena: false,
            sections: [],
            selectedSections: [],
            formData: [],
            showModal: false,
            tableTitle: "patient_list",
            isLoading: false,
            datosFormulario: {
                sensor: null,
                sensor_info: null,
                seccion: 1,
                id: 12,
                nombre: "",
                apellidos: "",
                fechaNacimiento: "2020-05-21",
                numeroHabitacion: "",
                observaciones: null,
                sexo: null,
                noUrine: false,
                noUrineAlarm: false,
                noUrineHours: 1,
                rotationAlarm: false,
                rotation: false,
                stoppedTime: 240,
                returnTime: 0,
                autoCorrectedAngle: false,
                allowActivityTracking: false,
                allowPatientLocation: false,
                autoCorrectedAngleValue: 10,
            },
            response: {
                lista: [],
            },
        };
    },
    computed: {
        filteredPatients: function () {
            if (this.response.lista && this.selectedSections.length > 0) {
                let list = [];
                this.response.lista.forEach((patient, index) => {
                    if (this.selectedSections.indexOf(patient.seccion) >= 0) {
                        list.push(patient);
                    }
                });
                return list;
            } else {
                return this.response.lista;
            }
        },
    },
    methods: {
        setPermissions() {
            let user = JSON.parse(localStorage.getItem("instantcare_user"));

            if (user.roles.includes("ROLE_CENTRO")) {
                this.permissionsAppQR = false;
                this.permissionsAdminCentro = true;
                this.permissionsAdminCadena = false;
            }
            if (user.roles.includes("ROLE_ENFERMERA")) {
                this.permissionsAppQR = true;
                this.permissionsAdminCentro = false;
                this.permissionsAdminCadena = false;
            }
        },
        onFormValidated(model) {
            this.datosFormulario = { ...this.datosFormulario, ...model };
        },
        openModal() {
            this.formConfig();
            this.showModal = true;
        },
        modalHide() {
            this.showModal = false;
        },
        submit() {
            this.$refs["formulario"].validate().then((res) => {
                if (res) {
                    fetch(`${BACKEND_API}/api/pacientes/new`, {
                        method: "POST",
                        headers: authHeader(),
                        body: JSON.stringify(this.datosFormulario),
                    })
                        .then(handleResponse)
                        .then((response) => {
                            this.fetchData();
                            this.modalHide();
                        });

                    this.modalHide();
                }
            });
        },
        formConfig() {
            fetch(`${BACKEND_API}/api/pacientes/prepare`, {
                method: "GET",
                headers: authHeader(),
            })
                .then((response) => response.json())
                .then((data) => (this.formData = data[1]));
        },
        fetchData() {
            let self = this;
            let url = `${BACKEND_API}/api/pacientes/list`;
            let currentCentro = JSON.parse(sessionStorage.getItem("idCentro"));
            if (currentCentro) {
                url = `${BACKEND_API}/api/pacientes/list?idCentro=${currentCentro.id}`;
            }
            this.sections = [];
            this.response = [];
            fetch(url, {
                method: "GET",
                headers: authHeader(),
            })
                .then(handleResponse)
                .then((response) => {
                    self.response = response;
                    self.sections = response.secciones;
                    self.isLoading = false;
                });
        },
    },
};
</script>

<style>
.section-filter {
    margin-top: -3px;
    margin-right: 10px;
}
</style>
